import { Link } from 'gatsby';
import { CodeWrapper, NcaLink, UsefulLink, UsefulLinksWrapper } from 'nca-acquiring-theme';
import { awsJdbcDriverConfigSnippet } from "../../../../src/snippets/AwsJdbcDriverSnippets";
import * as React from 'react';
export default {
  Link,
  CodeWrapper,
  NcaLink,
  UsefulLink,
  UsefulLinksWrapper,
  awsJdbcDriverConfigSnippet,
  React
};